import {AllDeviceActivity, StatusDeviceActivity} from "@containers/device/containers/deviceActivity/types";

export const getCalcKeyByStatusDeviceActivity = (status: StatusDeviceActivity): keyof AllDeviceActivity => {
    switch (status) {
        case "oneHour": {
            return 'totalOneHour'
        }
        case "beforeLastMonth": {
            return 'totalBeforeLastMonth'
        }
        case "inactive": {
            return 'totalInactive'
        }
        case "lastMonth": {
            return 'totalLastMonth'
        }
        case "lastDay": {
            return 'totalLastDay'
        }
        case "lastWeek": {
            return 'totalLastWeek'
        }
        case "notConnected": {
            return 'totalNotConnected'
        }
        case "online": {
            return 'totalOnline'
        }
    }
}

export const getStatusByCalcKeyDeviceActivity = (key:keyof AllDeviceActivity): StatusDeviceActivity => {
    switch (key) {
        case "totalOneHour": {
            return 'oneHour'
        }
        case "totalBeforeLastMonth": {
            return 'beforeLastMonth'
        }
        case "totalInactive": {
            return 'inactive'
        }
        case "totalLastMonth": {
            return 'lastMonth'
        }
        case "totalLastDay": {
            return 'lastDay'
        }
        case "totalLastWeek": {
            return 'lastWeek'
        }
        case "totalNotConnected": {
            return 'notConnected'
        }
        case "totalOnline": {
            return 'online'
        }
    }
}